import type { PlayersApi } from "@/v2/api/metadata/players";
import type { ContentTab, DialogTabSaveContext } from "@/v2/framework/dialog/types";
import { createInheritableTabSave } from "@/v2/kits/tenant-inheritance";
import { t } from "@/services/i18n";
import { PLAYER_MAX_POSITION, playerGamesStatusOptions } from "../../../../shared";
import { notifySuccess, playerId } from "../shared";

function positionValidator(value: unknown) {
  if (value == null || value === "") return undefined;
  if (Number(value) > PLAYER_MAX_POSITION) {
    return t("metadata.notifications.max_position", { max: PLAYER_MAX_POSITION });
  }
  return undefined;
}

const prematchTabChildren: ContentTab["children"] = [
  {
    type: "group",
    name: "prematchGame",
    label: "",
    children: [
      {
        type: "select-field",
        name: "status",
        label: "Status",
        required: true,
        placeholder: "Select status",
        options: playerGamesStatusOptions,
        inheritance: {
          computedKey: "computedStatus",
          parentKey: "parentStatus",
        },
      },
      {
        type: "text-field",
        name: "position",
        label: "Position",
        placeholder: "Enter position",
        validate: positionValidator,
        inheritance: {
          computedKey: "computedPosition",
          parentKey: "parentPosition",
        },
      },
    ],
  },
];

export function createPrematchTab(players: PlayersApi): ContentTab {
  const save = createInheritableTabSave({
    children: prematchTabChildren,
    persist: async (patch, ctx: DialogTabSaveContext) => {
      await players.update(playerId(ctx.values), patch);
      notifySuccess();
    },
  });

  return {
    id: "prematch",
    label: "Prematch",
    save,
    children: prematchTabChildren,
  };
}
